var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-armada bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-start shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 p-6 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Armada")]), _c('div', {
    staticClass: "mb-6 w-44"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": ""
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Armada",
      "placeholder": "Nama Armada"
    },
    model: {
      value: _vm.payloads.vehicle_name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "vehicle_name", $$v);
      },
      expression: "payloads.vehicle_name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Tahun Kendaraan",
      "placeholder": "Tahun Kendaraan"
    },
    model: {
      value: _vm.payloads.vehicle_production_year,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "vehicle_production_year", _vm._n($$v));
      },
      expression: "payloads.vehicle_production_year"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Plat Armada",
      "placeholder": "Plat Armada"
    },
    model: {
      value: _vm.payloads.vehicle_plat_id,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "vehicle_plat_id", $$v);
      },
      expression: "payloads.vehicle_plat_id"
    }
  })], 1), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Upload Dokumen")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('FileBrowser', {
    attrs: {
      "id": "stnk",
      "label": "Upload STNK",
      "accept": ".jpg, .png, .jpeg",
      "button": "Browse",
      "placeholder": "Pilih file yang akan di upload"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event, 'stnk', 'stnk_file_url');
      }
    }
  }), _vm.payloads.stnk_file_url ? _c('div', {
    staticClass: "w-40 mt-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.payloads.stnk_file_url
    }
  })]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('FileBrowser', {
    attrs: {
      "id": "bpkb",
      "accept": ".jpg, .png, .jpeg",
      "label": "Upload BPKB",
      "button": "Browse",
      "placeholder": "Pilih file yang akan di upload"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event, 'bpkb', 'bpkb_file_url');
      }
    }
  }), _vm.payloads.bpkb_file_url ? _c('div', {
    staticClass: "w-40 mt-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.payloads.bpkb_file_url
    }
  })]) : _vm._e()], 1), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Foto Pendukung")]), _c('div', {}, [_c('FileBrowser', {
    attrs: {
      "id": "foto",
      "accept": ".jpg, .png, .jpeg",
      "label": "Foto Armada",
      "button": "Browse",
      "placeholder": "Pilih file yang akan di upload"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event, 'armada', 'vehicle_photo_url');
      }
    }
  }), _vm.payloads.vehicle_photo_url ? _c('div', {
    staticClass: "w-40 mt-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.payloads.vehicle_photo_url
    }
  })]) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex-1 p-6 mdmax:flex-auto mdmax:w-full"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Tipe Kendaraan")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe Kendaraan")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.vehicleTypes,
      "optionLabel": "vehicle_name"
    },
    model: {
      value: _vm.selectedType,
      callback: function ($$v) {
        _vm.selectedType = $$v;
      },
      expression: "selectedType"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Min Berat")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": "",
      "placeholder": "Min Berat"
    },
    model: {
      value: _vm.payloads.minimum_supported_weight,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "minimum_supported_weight", _vm._n($$v));
      },
      expression: "payloads.minimum_supported_weight"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Box')], 1), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("Kg")])], 1)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Max Berat")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": "",
      "placeholder": "Max Berat"
    },
    model: {
      value: _vm.payloads.maximum_supported_weight,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "maximum_supported_weight", _vm._n($$v));
      },
      expression: "payloads.maximum_supported_weight"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Box')], 1), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("Kg")])], 1)])]), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Tipe Aset")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Aset")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.ownershipTypes,
      "optionLabel": "ownership_type"
    },
    model: {
      value: _vm.selectedAssetType,
      callback: function ($$v) {
        _vm.selectedAssetType = $$v;
      },
      expression: "selectedAssetType"
    }
  })], 1), _vm.visiblePartner ? _c('div', {
    staticClass: "dropdown mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kepemilikan Aset")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.partnerVehicle,
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedPartner,
      callback: function ($$v) {
        _vm.selectedPartner = $$v;
      },
      expression: "selectedPartner"
    }
  })], 1) : _vm._e(), _vm.selectedPartner ? _c('div', {
    staticClass: "shadow-border p-6 bg-neutral-200 rounded-md"
  }, [_c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedPartner.name))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedPartner.phone_number))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedPartner.address))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Total Aset")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedPartner.total_vehicle))])])]) : _vm._e(), _vm.selectedAssetType && _vm.selectedAssetType.ownership_type === 'company' ? _c('div', {}, [_c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('p', {
    staticClass: "text-lg font-bold"
  }, [_vm._v("Kurir")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari kurir"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.courier
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column,
            index = _ref.index;
        return [column.field === 'action' ? _c('Button', {
          attrs: {
            "buttonText": _vm.payloads.driver_id === entry.id ? 'Ditugaskan' : 'Tugaskan',
            "type": _vm.payloads.driver_id === entry.id ? 'primary' : 'secondary',
            "size": "small"
          },
          on: {
            "action": function ($event) {
              return _vm.assignCourier(entry);
            }
          }
        }) : column.field === 'no' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }], null, false, 2259153248)
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1) : _vm._e()])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }